import { render, staticRenderFns } from "./NotificationPermissionItem.vue?vue&type=template&id=88ee3eec&"
import script from "./NotificationPermissionItem.vue?vue&type=script&lang=js&"
export * from "./NotificationPermissionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports